import * as React from 'react'
import { ContextRoute } from '../app/context'
import { NavigationEntry, ServiceTypeNavigation } from '../service-type-navigation'

interface Props {
    currentRoute: ContextRoute
    navigationEntries: NavigationEntry[]
    showServiceOverviewModes: boolean
}

class MonitorNavigation extends React.Component<Props> {
    public static defaultProps = {
        showServiceOverviewModes: false,
    }

    public render = () => {
        return (
            <ServiceTypeNavigation
                navigationEntries={this.props.navigationEntries}
                currentRoute={this.props.currentRoute}
                showAddMarkerButton={false}
                showServiceOverviewModes={this.props.showServiceOverviewModes}
            />
        )
    }
}

export default MonitorNavigation
